import { Divider, ScrollArea, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { AllocationTypeFilter } from '../../filters/allocation-type/allocation-type-filter';
import { TaskTypeFilter } from '../../header/task-type-filter';
import { useScrollToTop } from '../../process-analysis.hooks';
import { Text } from '../../../../ui-library/typography/typography';
import { FiltersContent } from './filters-content';
import { FiltersHeader } from './filters-header';

export const Filters = () => {
  const { t } = useTranslation();
  const scrollAreaRef = useScrollToTop();

  return (
    <Stack gap="md" h="100%">
      <FiltersHeader />
      <Divider />
      <AllocationTypeFilter />
      <Stack gap={8}>
        <Text size="small" weight="bold">
          {t('process_analysis.filters.task_type', { defaultValue: 'Task Type' })}
        </Text>
        <TaskTypeFilter />
      </Stack>
      <Divider />
      <ScrollArea viewportRef={scrollAreaRef} h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <FiltersContent />
      </ScrollArea>
    </Stack>
  );
};
